import { useEffect, useState } from "react";
import axios from "axios";
import PublicBooking from "./PublicBooking";
import PublicAdAgency from "./PublicAdAgency";
import PublicStore from "./store/PublicStore";
import HotelStaffApp from "./hotel/HotelStaffApp";

export default function CustomDomainEntry() {
  const [state, setState] = useState({ loading: true, vertical: null, slug: null });

  useEffect(() => {
    const host = window.location.hostname;
    axios
      .get(`${window.location.origin}/api/public/resolve-host`, { params: { host } })
      .then(({ data }) => {
        setState({
          loading: false,
          vertical: data.vertical || "general",
          slug: data.public_booking_slug || data.client_id,
          ecommerce_enabled: !!data.ecommerce_enabled,
        });
      })
      .catch(() => setState({ loading: false, vertical: null, slug: null }));
  }, []);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-sm text-[#6B7280] font-mono uppercase tracking-widest animate-pulse">Loading...</div>
      </div>
    );
  }

  if (state.vertical === "retailer" && state.slug) {
    if (/^\/(hotel-staff|hotel-login|kitchen)(\/|$)/.test(window.location.pathname)) {
      const isKitchenPath = /^\/kitchen(\/|$)/.test(window.location.pathname);
      return <HotelStaffApp forcedClientRef={state.slug} forcedMode={isKitchenPath ? "kitchen" : "staff"} />;
    }
    return <PublicStore resolvedHost={window.location.hostname} clientRef={state.slug} />;
  }

  if (state.vertical === "retail_store" && state.slug) {
    return <PublicStore resolvedHost={window.location.hostname} clientRef={state.slug} />;
  }

  if (state.vertical === "ad_agency" && state.slug) {
    return <PublicAdAgency resolvedHost={window.location.hostname} clientRef={state.slug} />;
  }

  return <PublicBooking resolvedHost={window.location.hostname} />;
}
